<template>
  <navBack></navBack>
  <div class="page">


    <t-tabs default-value="0" @change="onTabsChange" t-class="custom-tabs">
      <t-tab-panel label="商品" value="0">
        <div class="productSort">
          <div class="aside">

            <t-side-bar :value="sideBarIndex" @change="onSideBarChange" @click="onSideBarClick">
              <t-side-bar-item v-for="(item, index) in categoryList" :key="index" :value="index" :label="item.title" />
            </t-side-bar>
          </div>

          <div class="center">
            <div ref="wrapper" class="content" @scroll="onScroll">
              <block v-for="(item, index) in categoryList" :key="item._id">
                <div class="categoryTitle">
                  {{ item.title }}
                </div>
                <div class="productItem" v-for="(pitem, pindex) in item.productList" :key="pitem._id">
                  <div class="productPic" @tap="godetail" :data-cindex="index" :data-pindex="pindex">
                    {{ pitem.pname }}
                  </div>
                  <div class="rightSection">
                    <div class="productTitle">{{ pitem.name }}</div>

                    <div class="price">￥{{ pitem.price / 100 }}</div>

                    <div class="van-stepper">
                      <t-stepper @change="(value) => handleCountChange(value, index, pindex)" v-model="pitem.count"
                        theme="filled" />
                    </div>

                  </div>
                </div>
              </block>
            </div>

          </div>
        </div>
      </t-tab-panel>

      <t-tab-panel label="次卡" value="1">
        <div class="section">
          <template v-for="(item, index) in userCardList" :key="item._id">
            <t-cell :title="item.product.name" hover :description="`剩余 ${item.cardCount}`">
              <template #note>
                <t-stepper @change="(value) => addCart_Cika(value, index)" v-model="item.shl" theme="filled"
                  :max="item.cardCount" />
              </template>
            </t-cell>
          </template>
        </div>
      </t-tab-panel>
    </t-tabs>


    <div class="cartBar" style="z-index: 11501">
      <div class="cartBarInner">
        <div class="leftPart" @click="togleShowCartList">
          <div class="BagIcon">
            <mp-icon icon="shop" color="white" :size="46"></mp-icon>
            <div class="cartCountBox">{{ sumCartCount }}</div>
          </div>
          <div class="priceInfo">￥{{ sumCartPrice / 100 }}</div>
        </div>
        <div class="rightPart" @click="doSubmit">
          提交
        </div>
      </div>
    </div>




    <t-popup :visible="isShowCartList" @onClose="isShowCartList = false" style="height:70vh" placement="bottom">
      <div class="cartBox">
        <div class="topBar2">
          <div class="leftItem">购物袋</div>

          <div class="rightItem">
            <t-button style="margin-right:3vw" size="extra-small" @click="clearMyCartList">清空</t-button>
            <t-button size="extra-small" @click="isShowCartList = false">关闭</t-button>
          </div>
        </div>

        <div class="inOnlyCartBox" :style="{ height: cartList.length * 98 + 'px', maxHeight: '50vh' }">
          <block v-for="(item2, index) in cartList" :key="index">

            <template v-if="item2.typeInfo == 'normal'">
              <t-cell :title="item2.name" hover :description="`￥${item2.price / 100}`">

                <template #image>
                  <div class="productPic"
                    style="width:12vw;height:12vw;border-radius:50%;text-align:center;line-height:12vw;font-size:4vw;flex-shrink:0;background-color:rgb(16,155,86);color:white;">
                    {{ item2.pname }}
                  </div>
                </template>
                <template #note>
                  <t-stepper @change="(value) => handleCartCountChange(value, index)" v-model="item2.shl"
                    theme="filled" />
                </template>
              </t-cell>
            </template>
            <template v-else-if="item2.typeInfo == 'cika'">
              <t-cell :title="item2.name" hover description="次卡抵扣">
                <template #image>
                  <div
                    style="width:12vw;height:12vw;border-radius:50%;text-align:center;line-height:12vw;font-size:4vw;flex-shrink:0;background-color:rgb(16,155,86);color:white;">
                    {{ item2.pname }}
                  </div>
                </template>
                <template #note>
                  <t-stepper @change="(value) => handleCartCountChange(value, index)" v-model="item2.shl" max="1"
                    theme="filled" />
                </template>
              </t-cell>
            </template>


          </block>
        </div>
        <div class="cartBottomBar"></div>
      </div>
    </t-popup>
  </div>

  <t-dialog v-model:visible="isShowDialog" title="请确认" :content="modalMsgInfo" confirm-btn="确认" cancel-btn="取消"
    @confirm="confirmClearMyCartList" @cancel="isShowDialog = false" :close-on-overlay-click="true">
  </t-dialog>
</template>

<script>
import { ref, onMounted, getCurrentInstance, reactive } from 'vue';

import { Toast } from 'tdesign-mobile-vue';
import { orderData, stateCustomer, stateCategoryList,stateShop } from '@/store.js'
import { useRouter } from 'vue-router';
import navBack from '@/components/nav-back-top.vue'
export default {
  name: 'ChoseProduct',
  components: {
    navBack
  },
  setup() {
    // 数据定义
    const userCardList = ref([]);

    const { proxy } = getCurrentInstance();

    const router = useRouter();
    const customer = reactive({});
    const activeTabIndex = ref(0);

    const isShowDialog = ref(false);
    const modalMsgInfo = ref('');

    const categoryList = ref([]);
    const asideScrollTop = ref(0);
    const navActive = ref(0);
    const toView = ref('');

    const height = ref(700);

    const cartList = ref([]);

    const isShowCartList = ref(false);

    const sumCartPrice = ref(0);
    const sumCartCount = ref(0);

    const produdctIdList = ref([]);


    const categoryCountList = ref({});

    const customerType = ref(2);

    const wrapper = ref(null);
    const offsetTopList = reactive([]);
    // const contentStyle = ref('');

    const goBackClick = () => {
      router.go(-1);
    };

    const app = proxy.$cloudbase; // Optional chaining to safely access $cloudbase

    let scrollTimer = null;
    const sideBarIndex = ref(1);

    // 方法定义


    const onTabsChange = (e) => {


      activeTabIndex.value = e;

    };

    const getOffsetTopList = () => {

      if (wrapper.value) {
        const $title = wrapper.value.querySelectorAll(`.categoryTitle`);
        $title.forEach((item) => offsetTopList.push(item.offsetTop));
      }

    };

    const moveToActiveSideBar = (index) => {
      if (wrapper.value) {
        wrapper.value.scrollTop = offsetTopList[index] - offsetTopList[0];
      }
    };


    const loadCateAndProductInfo = async () => {
      let categoryCountListObj = {};
      let productCountList = [];
      let categoryData = [];

      if (stateCategoryList.value.length)
      
      categoryData = stateCategoryList.value;
      else
        categoryData = await app.callFunction({
          name: 'openapi',
          data: {
            action: "getAllCategoryProduct",
            shopId: stateShop._id
          }

        }).then(res => {
        
          stateCategoryList.value = res.result;
          return res.result;

        });


      let _pindex = 0;
      let productIdList = [];

      categoryData.forEach(cate => {
        categoryCountListObj[cate._id] = 0;

        cate.productList.forEach(prod => {

          productCountList.push(0);
          productIdList.push(prod._id);
          prod["pindex"] = _pindex;
          prod["count"] = 0;
          prod["pname"] = prod.name ? prod.name.substring(0, 2) : '';
          _pindex++;
        });
      });

      categoryList.value = categoryData;
      produdctIdList.value = productIdList;
      categoryCountList.value = categoryCountListObj;



    };



    const loadCiKaList = () => {


      const db = app.database();

      db.collection('my_customer_card').where({
        'type': 2,
        status: 1,
        'customer._id': customer._id,
        'cardCount': { $gt: 0 }
      }).get().then(res => {
        for (let c of res.data) {
          c['minusCount'] = 0;
          c['shl'] = 0;
        }

        userCardList.value = res.data;
      })


    };








    const doSubmit = () => {
      if (cartList.value.length == 0) {
        Toast('未有选中的产品')
        return;
      }

      let cartListData = cartList.value;
      cartListData.forEach(item => {
        item.sumPrice2 = item.sumPrice;
      });



      orderData.cartList = cartListData;
      orderData.sumCartPrice = sumCartPrice.value;
      orderData.sumCartCount = sumCartCount.value;

      Object.keys(customer).forEach(key => {

        orderData.customer[key] = customer[key];

      })
      orderData.customerType = customerType.value;

      router.push({ path: '/confirmOrder' })



    };



    const togleShowCartList = () => {
      isShowCartList.value = !isShowCartList.value;
    };



    const scroll = () => {
      if (scrollTimer) clearTimeout(scrollTimer);

      scrollTimer = setTimeout(() => {

      }, 200);
    };


    const onSideBarClick = (value, label) => {
      console.log('[onSideBarClick]', { value, label });
    };

    const onSideBarChange = (value) => {
      sideBarIndex.value = value;
      moveToActiveSideBar(Number(value));
    };

    const handleCountChange = (value, cindex, pindex) => {
      const _currentProduct = categoryList.value[cindex].productList[pindex];
      _currentProduct.count = value;


      addCart(_currentProduct);




    }



    // 修复前的问题：
    // 1. for...of 循环语法错误，不应该使用括号包含多个变量
    // 2. 当 count 为 0 时直接 splice 可能导致索引问题
    // 3. 缺少对数组正确遍历和修改的方法

    // 修复后的代码：
    const addCart = async (currentProduct) => {
      let {
        categoryId,
        name,
        price,
        _id,
        pindex,
        topPic,
        productType,
        productType2
      } = currentProduct;

      let _cartList = cartList.value;
      let _isNewProduct = true;
      let foundIndex = -1;

      // 查找是否已存在该商品
      for (let i = 0; i < _cartList.length; i++) {
        if (_cartList[i]._id === _id) {
          _isNewProduct = false;
          foundIndex = i;
          break;
        }
      }

      if (!_isNewProduct) {
        // 更新现有商品
        _cartList[foundIndex].shl = currentProduct.count;
        _cartList[foundIndex].sumPrice = Number(price) * currentProduct.count;

        console.log('更新现有商品', currentProduct.count);
        // 如果数量为0，则移除商品
        if (currentProduct.count == 0) {
          _cartList.splice(foundIndex, 1);
          console.log('更新现有商品', _cartList);
        }
      } else if (currentProduct.count > 0) {
        // 添加新商品（仅当数量大于0时）
        let _data = {
          pindex,
          _id,
          shl: currentProduct.count,
          name,
          productType,
          productType2,
          price,
          typeInfo: 'normal',
          sumPrice: price * currentProduct.count,
          productPic: topPic,
          pname: name.substring(0, 2),
          categoryId,
          ticheng: [],
          type: 0
        };
        _cartList.push(_data);
      }

      handleCartUpdate(categoryId);
    };
    const onCartVisibleChange = (e) => {
      const visible = e.detail.visible;
      isShowCartList.value = visible;
    };


    const handleCartCountChange = (value, index) => {

      let _cartList = cartList.value;
      let _cartItem = _cartList[index];
      let price = Number(_cartItem.price);

      _cartItem.shl = value;
      _cartItem.sumPrice += price * value;

      if (value == 0)
        cartList.value.splice(index, 1);


      if (_cartItem.typeInfo == 'normal') {

        categoryList.value.forEach(item => {

          if (item._id == _cartItem.categoryId) {

            let productIndex = item.productList.findIndex(p => p._id == _cartItem._id);

            if (productIndex != -1) {
              item.productList[productIndex].count = value;
            }
          }
        });
      }



      else {
        let cardIndex2 = userCardList.value.findIndex(item => {
          return item.cardId = _cartItem.cardId;
        });

        userCardList.value[cardIndex2].minusCount -= 1;

        userCardList.value[cardIndex2].shl -= 1;

      }

      let categoryId = _cartItem.categoryId;
      handleCartUpdate(categoryId);
    };






    // 优化后的代码
    const handleCartUpdate = async (categoryId) => {


      // 更新分类计数

      categoryCountList.value[categoryId] = cartList.value.filter(item => item.categoryId == categoryId).reduce((total, item) => {
        return total + item.shl;
      }, 0);

      // 正确计算购物车总价和总数
      sumCartPrice.value = cartList.value.filter(item => item.typeInfo == 'normal').reduce((total, item) => {
        return total + (item.shl * item.price);
      }, 0);

      sumCartCount.value = cartList.value.reduce((total, item) => {
        return Number(total) + Number(item.shl);
      }, 0);
    };

    const clearMyCartList = () => {

      console.log('clearMyCartList');

      isShowDialog.value = true;
      modalMsgInfo.value = "确定清空购物车么";

    };

    const confirmClearMyCartList = () => {

      clearCartList2();
      togleShowCartList();
      Toast('购物车已清空')
    };


    const clearCartList2 = () => {


      for (let key in categoryCountList.value) {
        categoryCountList.value[key] = 0;
      }

      categoryList.value.forEach(item => {
        item.productList.forEach(p => {
          p.count = 0;
        });
      });

      userCardList.value.forEach(item => {
        item.minusCount = 0;
        item.shl = 0;
      });

      cartList.value = [];
      sumCartPrice.value = 0;
      sumCartCount.value = 0;
    };

    const addCart_Cika = (count, index) => {

      let _card = userCardList.value[index];

      if (count > _card.cardCount) {
        return;
      }




      let {
        product,
        cardCount
      } = _card;

      let _cartList = cartList.value;
      let {
        categoryId,
        name,
        _id,
        price,
        actualPrice,
        topPic,
        productType,
        productType2,
        type,
      } = product;

      if (_card.minusCount < count) {
        _cartList.push({
          categoryId,
          name,
          cardCount,
          _id,
          cardId: _card._id,
          typeInfo: "cika",
          price,
          productPic: topPic,
          pname: name.substring(0, 2),
          productType,
          productType2,
          ticheng: [],
          sumPrice: price,
          realPay: Number(actualPrice),
          actualPay: Number(actualPrice),
          operatePrice: 0,
          type,
          shl: 1,
          payWay: 'cika'
        });

      }

      else {
        let cardIndex = _cartList.findIndex(item => {
          return item.cardId == _card._id;
        });

        _cartList.splice(cardIndex, 1);
      }

      _card.minusCount = count;

      cartList.value = _cartList;
      handleCartUpdate(categoryId);
    };




    const onScroll = (e) => {
      const threshold = offsetTopList[0]; // 下一个标题与顶部的距离
      const { scrollTop } = e.target;
      if (scrollTop < threshold) {
        sideBarIndex.value = 0;
        return;
      }
      const index = offsetTopList.findIndex((top) => top > scrollTop && top - scrollTop <= threshold);

      if (index > -1) {
        sideBarIndex.value = index;
      }
    };

    // 生命周期
    onMounted(async () => {
      await loadCateAndProductInfo();
      Object.keys(stateCustomer).forEach(key => {
        customer[key] = stateCustomer[key];
      });

      console.log('customer', customer, stateCustomer);
      getOffsetTopList();
      loadCiKaList();
      moveToActiveSideBar(Number(sideBarIndex.value));

    });


    // 暴露给模板使用的数据和方法
    return {
      onSideBarChange,
      onSideBarClick,
      wrapper,
      handleCartCountChange,
      onScroll,
      isShowDialog,
      modalMsgInfo,
      // 数据
      userCardList,
      activeTabIndex,
      categoryList,
      asideScrollTop,
      navActive,
      toView,
      height,
      cartList,
      isShowCartList,
      sumCartPrice,
      sumCartCount,
      categoryCountList,
      customerType,
      customer,
      confirmClearMyCartList,
      sideBarIndex,
      onTabsChange,
      togleShowCartList,
      doSubmit,
      scroll,
      handleCountChange,
      onCartVisibleChange,

      goBackClick,
      clearMyCartList,
      addCart_Cika

    };
  }
};
</script>

<style scoped>
/* 这里需要将原来的WXSS样式转换为CSS */
.page {
  padding-bottom: 10vh;
}

.head {


  width: 100vw;

  background-color: #f6f6f6;
}

.head .headBar {
  text-align: center;
  height: 3vw;
  position: relative;
  padding-top: 4.3vw;
}

.head .topBox {
  display: flex;
  justify-content: space-between;
  padding-top: 1vw;
  height: 5vw;
  background-color: #f7f7f7;
}

.head .topBox .leftBox {
  width: 68vw;
  padding-left: 2vw;
}

.cikaPaddingPanel {
  height: 20vw;
}

.head .topBox .leftBox .SubBar {
  font-size: 1.2vw;
  color: gray;
}

.head .topBox .rigthBox {
  width: 24vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-right: 2.5vw;
}

.head .rigthBox .checkBox {
  height: 2.5vw;
  padding: 0.2vw;
  display: flex;
  background-color: rgb(16, 155, 86);
  align-items: center;
  border-radius: 1.45vw;
  justify-content: space-between;
  color: white;
}

.head .topBox .rigthBox .checkBox .checkTakeSelf,
.rigthBox .checkBox .checkTakeOut {
  height: 2.5vw;
  line-height: 2.5vw;
  border-radius: 1.25vw;
  width: 49%;
  text-align: center;
  font-size: 1.2vw;
}

.head .topBox .rigthBox .checkBox .checked {
  background-color: white;
  color: rgb(16, 155, 86);
}

.head .headBar {
  width: 24vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-right: 2.5vw;
  padding-left: 1.5vw;
  font-size: 1rem;
}

.head .headBar .checkBox {
  height: 2.5vw;
  padding: 0.2vw;
  display: flex;
  color: rgb(180, 180, 180);
  border-radius: 1.45vw;
  justify-content: space-between;
  align-items: center;
}

.head .headBar .checkBox .checkTakeSelf,
.headBar .checkBox .checkTakeOut {
  height: 2.5vw;
  line-height: 2.5vw;
  border-radius: 1.25vw;
  width: 49%;
  text-align: center;
}

.head .headBar .checkBox .checked {
  color: black;
  font-size: 1.1rem;
  font-weight: 700;
}

.productSort {
  display: flex;
}

.productSort .aside {
  width: 24vw;
  background-color: #f5f5f5;
  overflow-x: hidden;
}

.productSort .aside .item {
  padding: 1.25vw 0;
  width: 100%;
  font-size: 1.3vw;
  color: #424242;
  text-align: center;
  border-left: 0.2vw solid #f7f7f7;
  position: relative;
  box-sizing: border-box;
}

.productSort .aside .item .cateIcon {
  height: 3vw;
  display: flex;
  justify-content: center;
}

.productSort .aside .item .cateIcon image {
  width: 3vw;
  height: 3vw;
}

.productSort .aside .item .cateTitle {
  text-align: center;
}


.productSort .center {
  padding: 0 1vw;
  width: 54vw;
  background-color: rgb(255, 255, 255);
  min-height: 80vh;
}

.productSort .center .categoryTitle {
  height: 9.5vw;
  font-size: 14px;
  text-align: left;
  line-height: 4.5vw;
  padding-top: 2vw;
  margin: 3vw 1vw;
  color: gray
}

.productItem {
  display: flex;
  padding: 2.5vw 0.8vw;

}

.productItem .productPic {
  width: 12vw;
  height: 12vw;
  border-radius: 50%;
  text-align: center;
  line-height: 12vw;
  font-size: 4vw;
  flex-shrink: 0;
  background-color: rgb(16, 155, 86);
  color: white;
}

.productItem .productPic image {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}

.productItem .rightSection {
  width: 45vw;
  height: 12vw;
  box-sizing: border-box;
  padding: 1vw 0;
  padding-left: 2vw;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  position: relative;
}

.productItem .rightSection .productTitle {

  font-size: 3.5vw;
  line-height: 3.5vw;
  padding-bottom: 1vw;
  text-align: left;
  color: rgb(81, 81, 81);
}



.productItem .rightSection .price {
  font-size: 3.5vw;
  height: 3.5vw;
  color: rgb(124, 124, 124);

}


.van-stepper {
  position: absolute;
  right: 0;
  bottom: 3vw;
  display: flex;

  height: 2.4vw;
  width: 7.6vw;
}





.van-stepper2 {
  right: 0;
  bottom: 0;
  display: flex;
}

.van-stepper2 .stepperValue {
  width: 8vw;
  text-align: center;
  line-height: 2.4vw;
  font-size: 1.4vw;
}

.skuChoseBox {
  padding: 0.6vw;
  height: 100%;
  position: relative;
}

.skuChoseBox .productImg {
  background-color: white;
  border-radius: 1vw;
  position: absolute;
  top: -3vw;
  padding: 1vw;
  box-shadow: 1px 2px 1px #f7f7f7;
}

.skuChoseBox .productInfo {
  display: flex;
  justify-content: space-between;
}

.skuChoseBox .productSpace {
  width: 32vw;
}

.skuChoseBox .productImg image {
  width: 30vw;
  height: 30vw;
}

.skuChoseBox .titleLable {
  padding-top: 12vw;
  font-weight: 600;
  font-size: 1.8vw;
  width: 48vw;
}

.buyBar .skuLable {
  color: rgb(158, 158, 158);
  font-size: 1.4vw;
}

.buyBar .bottomBtn {
  padding-bottom: 3vw;
}

.buyBar .bottomBtn .btnSubmit {
  display: block;
  background-color: var(--ThemeColor);
  color: white;
  border-radius: 2.1vw;
  width: 62vw;
}


.productDialog {
  padding: 2vw;
  width: 94vw;
}

.topBar {
  display: flex;
  position: relative;
}



.productInfo {
  height: 32vw;
}


.optionItem {
  width: 22vw;
  padding: 0.8vw 0.6vw;
  text-align: center;
  color: rgb(70, 70, 70);
  border-radius: 0.8vw;
}

.activeOption {
  background-color: rgb(240, 240, 240);
  color: rgb(56, 56, 56);
}

.rightContent {
  width: 83vw;
  padding-left: 0.8vw;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}

.mibBar {
  height: 22vw;
}

.buyBar {
  background-color: white;
  padding: 2vw 3vw;
  border-top: 0.05vw solid rgb(235, 235, 235);
}




.cartBar_cika {
  z-index: 10000;
  width: 100vw;
  position: fixed;
  bottom: 2rem;
  height: 2.5vw;
}


.cartBarInner {

  width: 90vw;
  margin: 0 auto;
  background-color: rgb(54, 54, 54);
  height: 50px;
  border-radius: 25px;
  display: flex;
}

--td-tab-item-height {
  height: 72px;
}

.cartBarInner .leftPart {
  width: 70vw;
  display: flex;

}

.cartBarInner .leftPart .BagIcon {
  margin-left: 10px;
  position: relative;
}

.cartBarInner .leftPart .BagIcon .cartCountBox {

  position: absolute;
  left: -6px;
  top: -10px;
  width: 26px;
  height: 26px;
  line-height: 24px;
  background-color: rgb(16, 155, 86);
  color: white;
  border-radius: 13px;
  text-align: center;

}

.cartBarInner .leftPart .priceInfo {
  line-height: 50px;
  color: white;
  font-size: 1.2rem;
}

.cartBar .rightPart {
  width: 30vw;
  background-color: rgb(16, 155, 86);
  border-radius: 25px;
  color: white;
  line-height: 50px;
  font-size: 1.3rem;
  text-align: center;
  font-weight: 600;
}

.darkBtn {
  background-color: rgb(130, 131, 130);
}

.cartBar {
  z-index: 10000;
  width: 100vw;
  position: fixed;
  bottom: 2rem;
  height: 12vw;

}

.cartBox {
  display: block;
  width: 100vw;
  padding-bottom: 12vw;

}

.carBox .productPic {
  width: 12vw;
  height: 12vw;
  border-radius: 50%;
  text-align: center;
  line-height: 12vw;
  font-size: 4vw;
  flex-shrink: 0;
  background-color: rgb(16, 155, 86);
  color: white;
}


.topBar2 {
  display: flex;
  justify-content: space-between;
  padding: 2vw;
  border-bottom: 0.1vw solid rgb(240, 239, 239);
  font-size: 1rem;
  box-sizing: border-box;
  width: 100vw;
}

.topBar2 .rightItem {
  line-height: 100%;
  display: flex;
  align-items: center;
}



.swiperBox {
  height: 28vw;
  width: 56vw;
  padding: 0.5vw;
}



.swiperBox image {
  height: 32vw;
  width: 56vw;
  border-radius: 0.6vw;
}

.cartProductItem {
  display: flex;
  padding: 1.5vw 0.8vw;

  justify-content: space-between;
}

.cartProductTitle {
  color: rgb(85, 85, 85);
  font-size: 1rem;
}

.cartProductLable {
  font-size: 1rem;
  color: rgb(80, 80, 80);
}

.cartProductPrice {
  font-size: 1.2rem;
}

.prodtImg {
  flex-shrink: 0;
  width: 4.8vw;
  height: 4.8vw;
}

.prodtImg image {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}

.cartProductBox2 {
  height: 2.6vw;
  line-height: 2.6vw;
  display: flex;
  justify-content: space-between;
}

.cartProductOprate {
  width: 9vw;
}

.closeIcon {
  position: absolute;
  right: 0px;
  width: 3vw;
  height: 3vw;
  top: 1vw;
}



.cartBottomBar {
  height: 3.75vw;
}

.noscroll {
  overflow: hidden;
}

.input-class {
  height: 3.2vw;
}

.choseCoupon2 {
  background-color: tomato;
}


.flexBox {
  display: flex;
}

.cate_num {
  position: absolute;
  right: 0.6vw;
  top: 0.8vw;
  border-radius: 0.7vw;
  width: 1.4vw;
  height: 1.4vw;
  line-height: 1.4vw;
  background-color: rgb(58, 158, 19);
  font-size: 1vw;
  color: white;
}

/* 其他样式需要根据原有WXSS进行转换 */
</style>